import { Form, Input, Select } from "antd";
import React from "react";
import Button from "../../components/Button";
import { AllTickets, UpdateTicket } from "./service";
import { useDispatch, useSelector } from "react-redux";
import { setTicketLoading } from "../../actions/TicketsAction";
import "./style.css";
export const Details = () => {
  const [form] = Form.useForm();
  const state = useSelector((state) => state?.ticketState);
  const dispatch = useDispatch();
  const handleEdit = async (values) => {
    dispatch(setTicketLoading(true));
    await UpdateTicket(dispatch, values, state?.editModal?.data?.id);
    await AllTickets(dispatch);
    dispatch(setTicketLoading(false));
  };

  return (
    <div className="flex flex-col items-center justify-center items-center text-xl">
      <span>Update Status</span>

      <Form
        onFinish={handleEdit}
        form={form}
        layout="vertical"
        style={{ width: "85%", marginTop: "50px" }}
        initialValues={{
          name: state?.editModal?.data?.client_name,
          company: state?.editModal?.data?.company_name,
          email: state?.editModal?.data?.email,
          phone_number: state?.editModal?.data?.phone_number,
          ticket_type: state?.editModal?.data?.ticket_type,
          status: state?.editModal?.data?.status,
        }}
      >
        <Form.Item name="name" label="Client Name">
          <Input disabled={true} />
        </Form.Item>
        <Form.Item name="company" label="Company Name">
          <Input disabled={true} />
        </Form.Item>

        <Form.Item name="email" label="Email">
          <Input disabled={true} />
        </Form.Item>
        <Form.Item name="phone_number" label="Phone Number">
          <Input disabled={true} />
        </Form.Item>
        <Form.Item name="ticket_type" label="Ticket Type">
          <Input disabled={true} />
        </Form.Item>
        <Form.Item name="status" label="Status">
          <Select
            options={[
              { label: "Open", value: "open" },
              {
                label: "Close",
                value: "close",
              },
              {
                label: "In Progress",
                value: "in_progress",
              },
            ]}
          ></Select>
        </Form.Item>

        <Form.Item>
          <div>
            <Button
              label="Change Status of Ticket"
              type="submit"
              htmlType="submit"
            />
          </div>
        </Form.Item>
      </Form>
    </div>
  );
};
